// libraries
import React from 'react';
import PropTypes from 'prop-types';

// shared
import Label from 'shared/components/label';
import TextInput from 'shared/components/text-input';

const propTypes = {
  identifier: PropTypes.object.isRequired,
  password: PropTypes.object.isRequired,
  identifierHeader: PropTypes.string,
  identifierDisabled: PropTypes.bool,
  passwordHeader: PropTypes.string
};

const defaultProps = {
  identifierHeader: 'Email or Phone Number',
  passwordHeader: 'Password',
  identifierDisabled: false
};

const CredentialsInput = ({identifier, password, identifierHeader, passwordHeader, identifierDisabled}) => (
  <div className="oauth-credentials-input">
    <legend className="shared-required-legend"></legend>
    <Label required autoId="oauth-email-or-phone">
      {identifierHeader}
      <TextInput {...identifier}
        placeholder=""
        active={false}
        disabled={identifierDisabled}
        id="desktop-login-input"
        required
      />
    </Label>
    <Label required autoId="oauth-password">
      {passwordHeader}
      <TextInput
        {...password}
        type="password"
        id="desktop-password-input"
        placeholder=""
        required />
    </Label>
  </div>
);

CredentialsInput.propTypes = propTypes;
CredentialsInput.defaultProps = defaultProps;

export default CredentialsInput;
